import { Link } from 'react-router-dom';

const HeroSection = () => {
  return (
    <section className="relative w-full h-[100vh] min-h-[640px] flex items-center overflow-hidden">
      {/* Background Image – echtes Foto von gowitec.de */}
      <div className="absolute inset-0">
        <img
          src="/images/oben1.jpg"
          alt="gowiTEC – Maschinenbau und Automatisierung"
          className="w-full h-full object-cover object-center"
          loading="eager"
          fetchPriority="high"
          decoding="async"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0f1f4a] via-[#0f1f4a]/88 to-[#0f1f4a]/50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 md:px-10 pt-20">
        <div className="max-w-2xl">
          <div className="flex items-center gap-2 mb-6">
            <span className="w-8 h-0.5 bg-[#DC2626]"></span>
            <span className="text-[#DC2626] text-xs font-semibold tracking-widest uppercase">Seit 1992</span>
          </div>
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
            Individuelle Lösungen für{' '}
            <span className="text-[#DC2626]">Maschinenbau,</span>{' '}
            SPS und Automation
          </h1>
          <p className="text-white/80 text-base md:text-xl leading-relaxed mb-10 max-w-xl">
            gowiTEC entwickelt und realisiert maßgeschneiderte Automatisierungslösungen, Sondermaschinen, Steuerungssysteme und Lasertechnik – praxisnah, zuverlässig und auf Ihre Anforderungen zugeschnitten.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <Link
              to="/anfrage"
              className="bg-[#DC2626] hover:bg-[#b91c1c] text-white font-semibold px-8 py-4 rounded-md transition-all duration-200 text-center whitespace-nowrap cursor-pointer text-base"
            >
              Jetzt Projekt anfragen
            </Link>
            <Link
              to="/leistungen"
              className="border-2 border-white/70 hover:border-white text-white font-semibold px-8 py-4 rounded-md transition-all duration-200 text-center whitespace-nowrap cursor-pointer text-base hover:bg-white/10"
            >
              Unsere Leistungen
            </Link>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <span className="text-white/50 text-xs tracking-widest uppercase">Mehr</span>
        <span className="w-5 h-5 flex items-center justify-center"><i className="ri-arrow-down-line text-white/50"></i></span>
      </div>
    </section>
  );
};

export default HeroSection;
